import { React } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';

const NoticeInfo = (props) => {
  const { data, index, clickFn } = props;

  const { t } = useLanguage();

  return (
    <TopLevelWrapper onClick={() => clickFn(index)}>
      <TextWrapper>
        <Title>{data.title}</Title>
      </TextWrapper>
      <TextWrapper>
        <CreatedDate>{moment(data.createdDate).format(t('noticePage.dateFormatShort'))}</CreatedDate>
        <CommentCountText>{t('main.notice.commentCount', { count: data.commentCount + data.replyCount })}</CommentCountText>
      </TextWrapper>
    </TopLevelWrapper>
  )
}

export default NoticeInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-itmes: center;

  width: 964px;
  height: 28px;

  margin: 0 0 0 0;
  padding: 0 8px 0 8px;

  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.background};
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const CommentCountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.subText};
`;

const CreatedDate = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.subText};
`;